import { KnmCollapse } from 'KnmPackage/MainModule/components/KnmCollapse';
import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';
import { IKnmErpObjectResultSelectOption } from 'KnmErpPackage/MainModule/interfaces/IKnmErpObjectResultSelectOption';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { TextareaField } from 'UIPackage/MainModule/components/TextareaField';
import { Row } from 'UIPackage/FormModule/components/Row';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';

import { IKnmErpFormResultCancellationInfo } from '../interfaces/IKnmErpFormResultCancellationInfo';

const COLLAPSE_TITLE_BASE = 'Отмена';

interface IKnmErpResultCancellationInfoProps {
  id: string;
  index: number;
  knmObjectsResultsSelectOptions: IKnmErpObjectResultSelectOption[] | undefined;
  name: string;
  resultsCancellationInfo: IKnmForm['resultsCancellationInfo'];
  value: IKnmErpFormResultCancellationInfo | undefined;
  watchOnly?: boolean;
  onRemove: () => void;
}

export const KnmErpResultCancellationInfo = ({
  id,
  index,
  knmObjectsResultsSelectOptions,
  name,
  resultsCancellationInfo,
  value,
  watchOnly,
  onRemove,
}: IKnmErpResultCancellationInfoProps) => {
  const customKnmObjectsResultsSelectOptions:
    | IKnmErpObjectResultSelectOption[]
    | undefined = knmObjectsResultsSelectOptions?.map(knmObjectResultSelectOption => ({
    ...knmObjectResultSelectOption,
    isDisabled: resultsCancellationInfo?.some(
      resultCancellationInfo =>
        knmObjectResultSelectOption.id === resultCancellationInfo?.result?.id &&
        knmObjectResultSelectOption.id !== value?.result?.id,
    ),
  }));

  return (
    <Row>
      <KnmCollapse
        id={id}
        theme="fields"
        title={value?.isNew ? COLLAPSE_TITLE_BASE : `${COLLAPSE_TITLE_BASE} №${index + 1}`}
        subtitle={value?.result?.label}
        isNew={value?.isNew}
        openByDefault={value?.isNew}
        onClose={onRemove}
      >
        <>
          <Row>
            <FieldBlock label="Результат">
              <SelectInputField
                name={`${name}.result`}
                options={customKnmObjectsResultsSelectOptions}
                disabled={watchOnly}
                size="medium"
              />
            </FieldBlock>
          </Row>
          <FieldBlock label="Сведения об отмене результатов КНМ (в случае если такое КНМ было произведено)">
            <TextareaField
              name={`${name}.information`}
              placeholder="Введите сведения об отмене результатов КНМ"
              disabled={watchOnly}
            />
          </FieldBlock>
        </>
      </KnmCollapse>
    </Row>
  );
};
